import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { catchError, from, switchMap, tap } from 'rxjs';
interface Meta {
  buildTime: number;
  version?: string;
}

const isStale = (latest: Meta, current: Meta): boolean => {
  return latest.buildTime !== current.buildTime;
};

const CacheBuster: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    from(fetch('/meta.json', { cache: 'force-cache' }))
      .pipe(
        switchMap((response) => from(response.json() as Promise<Meta>)),
        tap((meta: Meta) => {
          // cache : reload update the cache with the latest meta.json
          // we should fetch /meta.json in that order not in parallel
          from(fetch('/meta.json', { cache: 'reload' }))
            .pipe(
              switchMap((response) => from(response.json() as Promise<Meta>)),
              tap((currentMeta: Meta) => {
                if (isStale(meta, currentMeta)) {
                  window.location.reload();
                }
              })
            )
            .subscribe();
        }),
        catchError((err) => {
          console.error('Error loading meta.json:', err);
          return [];
        })
      )
      .subscribe();
  }, [location]);

  return <>{children}</>;
};

export default CacheBuster;
